export const CREATE_SUPERVISOR = 'supervisor';
export const GET_PROJET = 'GET_PROJET';
export const VALET_LIST = 'VALET_LIST';
export const DELETE_SUPERVISOR  = 'DELETE_SUPERVISOR';
export const ALL_VALET_LIST_DATA = 'ALL_VALET_LIST_DATA';
export const ALL_SUPERVISOR_LIST_DATA = 'ALL_SUPERVISOR_LIST_DATA';
export const UPDATE_SUPERVISOR_LIST_DATA = 'UPDATE_SUPERVISOR_LIST_DATA';
export const UPDATE_VALET_LIST_DATA = 'UPDATE_VALET_LIST_DATA';
export const ATTENDANCE_REQUEST_LIST = 'ATTENDANCE_REQUEST_LIST';
export const GET_ALL_DAYS = "GET_ALL_DAYS";
export const VALET_ATTENDANCE_REQUEST = 'VALET_ATTENDANCE_REQUEST';
export const ALL_VALET_USERS = 'ALL_VALET_USERS';